import { render, staticRenderFns } from "./DisplayStoreItemsList2.vue?vue&type=template&id=ea5f7f3a&"
import script from "./DisplayStoreItemsList2.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsList2.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsList2.vue?vue&type=style&index=0&id=ea5f7f3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports